import React from 'react';

export const FillPowerRightImage = () => {
  return (
    <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/fillpower/fillpower-lower-two.jpg")`}}></div>
  );
};